import { makeSubject as t, toPromise as r, take as e, filter as n, onStart as o, map as u, merge as a } from "wonka";

import { createRequest as i, makeOperation as h } from "@urql/core";

var addAuthAttemptToOperation = (t, r) => h(t.kind, t, {
  ...t.context,
  authAttempt: r
});

function authExchange(f) {
  return ({client: d, forward: c}) => {
    var p = new WeakSet;
    var s = t();
    var l = new Map;
    function flushQueue(t) {
      if (t) {
        v = t;
      }
      A = void 0;
      var r = l;
      l = new Map;
      r.forEach(s.next);
    }
    var A;
    var v = null;
    return t => {
      A = Promise.resolve().then((() => f({
        mutate(t, u, a) {
          var h = d.createRequestOperation("mutation", i(t, u), a);
          return r(e(1)(n((t => t.operation.key === h.key))(o((() => {
            var t = addAuthToOperation(h);
            p.add(t);
            s.next(t);
          }))(w))));
        },
        appendHeaders(t, r) {
          var e = "function" == typeof t.context.fetchOptions ? t.context.fetchOptions() : t.context.fetchOptions || {};
          return h(t.kind, t, {
            ...t.context,
            fetchOptions: {
              ...e,
              headers: {
                ...e.headers,
                ...r
              }
            }
          });
        }
      }))).then(flushQueue);
      function refreshAuth(t) {
        l.set(t.key, addAuthAttemptToOperation(t, !0));
        if (v && !A) {
          A = v.refreshAuth().finally(flushQueue);
        }
      }
      function addAuthToOperation(t) {
        return v ? v.addAuthToOperation(t) : t;
      }
      var x = n((t => "teardown" === t.kind))(t);
      var k = n((t => "teardown" !== t.kind))(t);
      var m = n(Boolean)(u((t => {
        if (t.context.authAttempt) {
          return addAuthToOperation(t);
        } else if (p.has(t)) {
          return t;
        } else if (A) {
          if (!l.has(t.key)) {
            l.set(t.key, addAuthAttemptToOperation(t, !1));
          }
          return null;
        } else if (function willAuthError(t) {
          return !t.context.authAttempt && v && v.willAuthError && v.willAuthError(t);
        }(t)) {
          refreshAuth(t);
          return null;
        }
        return addAuthToOperation(addAuthAttemptToOperation(t, !1));
      }))(a([ s.source, k ])));
      var w = c(a([ m, x ]));
      return n((t => {
        if (t.error && function didAuthError(t) {
          return v && v.didAuthError && v.didAuthError(t.error, t.operation);
        }(t) && !t.operation.context.authAttempt) {
          refreshAuth(t.operation);
          return !1;
        }
        return !0;
      }))(w);
    };
  };
}

export { authExchange };
//# sourceMappingURL=urql-exchange-auth.mjs.map
